import Vue from "vue";

// Remove documentos global
export async function deleteRequestedDocuments(ids) {
  const response = await Vue.prototype.$http.delete(
    "/requested_documents/destroy",
    {
      data: { ids },
    }
  );
  return response.data;
}

// Marca documento como recebido
export async function updateReceiptDate(requested_document_id, payload = {}) {
  const response = await Vue.prototype.$http.put(
    `/requested_documents/${requested_document_id}/receipt_date`,
    payload
  );
  return response.data;
}

// Marca documentos como recebidos de forma massiva
export async function updateReceiptDatesBulk(ids, receiptDate) {
  const response = await Vue.prototype.$http.put(
    `/requested_documents/receipt_dates_bulk`,
    {
      ids,
      receipt_date: receiptDate,
    }
  );
  return response.data;
}
